import React, { useState } from 'react';
import { Modal, Spinner } from '../../components/base';

function PartnerDetail({ partner, onClose, onEdit, onDelete, onGeneratePortalLink, onRevokePortalLink, isAdmin }) {
  const [generating, setGenerating] = useState(false);
  const [copied, setCopied]         = useState(false);
  const portalUrl = partner.portal_token
    ? `${window.location.origin}${window.location.pathname}?portal=${partner.portal_token}`
    : null;

  const handleGenerate = async () => {
    setGenerating(true);
    await onGeneratePortalLink(partner.id);
    setGenerating(false);
  };
  const handleCopy = () => {
    if (!portalUrl) return;
    navigator.clipboard.writeText(portalUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  const handleRevoke = async () => {
    if (!confirm('Revogar o link atual? O parceiro perderá o acesso.')) return;
    await onRevokePortalLink(partner.id, partner.portal_token);
  };

  const Row = ({label, value}) => value ? (
    <div className="flex gap-2 text-sm py-1.5 border-b border-gray-50 last:border-0">
      <span className="text-gray-400 w-32 flex-shrink-0">{label}</span>
      <span className="text-gray-800 font-medium break-all">{value}</span>
    </div>
  ) : null;

  return <Modal title={partner.name} onClose={onClose} wide>
    <div className="space-y-4">
      {partner.default_commission > 0 && (
        <div className="bg-purple-50 border border-purple-200 rounded-xl px-4 py-2.5 flex items-center gap-3">
          <span className="text-2xl font-bold text-purple-700">{partner.default_commission}%</span>
          <span className="text-sm text-purple-600">comissão padrão</span>
        </div>
      )}
      <div>
        <p className="text-xs font-bold text-gray-400 mb-2">Identificação</p>
        <Row label="Nome completo" value={partner.full_name} />
        <Row label="CPF" value={partner.cpf} />
        <Row label="CNPJ" value={partner.cnpj} />
      </div>
      <div>
        <p className="text-xs font-bold text-gray-400 mb-2">Contato</p>
        <Row label="E-mail" value={partner.email} />
        <Row label="Telefone" value={partner.phone} />
      </div>
      {(partner.address||partner.city||partner.zip) && <div>
        <p className="text-xs font-bold text-gray-400 mb-2">Endereço</p>
        <Row label="Endereço" value={partner.address} />
        <Row label="Cidade / Estado" value={[partner.city, partner.state].filter(Boolean).join(' — ')} />
        <Row label="CEP" value={partner.zip} />
      </div>}
      {(partner.bank_pix||partner.bank_name) && <div>
        <p className="text-xs font-bold text-gray-400 mb-2">Dados Bancários</p>
        <Row label="PIX" value={partner.bank_pix} />
        <Row label="Banco" value={partner.bank_name} />
        <Row label="Agência" value={partner.bank_agency} />
        <Row label="Conta" value={partner.bank_account} />
      </div>}
      {partner.notes && <div className="bg-gray-50 rounded-xl p-3 text-sm text-gray-700 whitespace-pre-wrap">{partner.notes}</div>}

      {/* ── Link do Portal ── */}
      <div className="border-t pt-4">
        <p className="text-xs font-bold text-gray-400 mb-3">🔗 Link do Portal</p>
        {portalUrl ? (
          <div className="space-y-2">
            <div className="bg-blue-50 border border-blue-200 rounded-xl px-3 py-2.5">
              <p className="text-xs text-blue-400 font-medium mb-1">Link ativo — compartilhe com o parceiro</p>
              <p className="text-xs text-blue-700 font-mono break-all">{portalUrl}</p>
            </div>
            <div className="flex gap-2">
              <button onClick={handleCopy}
                className={`flex-1 text-sm py-2 rounded-full font-semibold transition-colors ${copied ? 'bg-green-500 text-white' : 'bg-blue-500 text-white hover:bg-blue-600'}`}>
                {copied ? '✅ Copiado!' : '📋 Copiar Link'}
              </button>
              {isAdmin && <button onClick={handleGenerate} disabled={generating}
                className="text-sm px-4 py-2 rounded-full font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200 disabled:opacity-50">
                🔄 Novo
              </button>}
              {isAdmin && <button aria-label="Bloquear" onClick={handleRevoke}
                className="text-sm px-4 py-2 rounded-full font-semibold bg-red-50 text-red-500 hover:bg-red-100">
                🚫
              </button>}
            </div>
          </div>
        ) : (
          isAdmin
            ? <button onClick={handleGenerate} disabled={generating}
                className="w-full bg-blue-500 text-white text-sm py-2.5 rounded-full font-semibold hover:bg-blue-600 disabled:opacity-50 flex items-center justify-center gap-2">
                {generating ? <><Spinner/> Gerando…</> : '🔗 Gerar Link do Portal'}
              </button>
            : <p className="text-sm text-gray-400">Nenhum link gerado ainda. Solicite ao admin.</p>
        )}
      </div>

      {isAdmin && <div className="flex gap-2 pt-2 border-t border-black/[0.06]">
        <button onClick={onEdit} className="flex-1 bg-blue-50 text-blue-600 rounded-full py-2 text-sm font-semibold hover:bg-blue-100">✏️ Editar</button>
        <button aria-label="Excluir" onClick={onDelete} className="bg-red-50 text-red-500 rounded-full py-2 px-5 text-sm font-semibold hover:bg-red-100">🗑</button>
      </div>}
    </div>
  </Modal>;
}

// ─── SellerForm ───────────────────────────────────────────

export { PartnerDetail };
